const SET_DM_INFO = data => {
  window.localStorage.setItem("DM_BRAND_INFO",data)
};
export default{
  SET_DM_INFO
}